import { userEmailsCanChangeManagementCompany } from 'constants/index'

export function canChangeManagementCompany({ isInternalAdmin, userEmail }) {
  if (!isInternalAdmin || !userEmail) {
    return false
  }

  return userEmailsCanChangeManagementCompany.includes(userEmail)
}
